import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    Image,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow } from "../../../components/EmptyRow";
import { InventoryCategory } from "../../../forms/InventoryCategoryForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const InventoryCategoryTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: InventoryCategoryTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [
        deleteInventoryCategoryModalShowing,
        setDeleteInventoryCategoryModalShowing,
    ] = useState(false);
    const [deleteInventoryCategoryName, setDeleteInventoryCategoryName] =
        useState("");
    const [deleteInventoryCategoryId, setDeleteInventoryCategoryId] =
        useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>{trans("Name")}</th>
                        <th>{trans("Description")}</th>
                        <th>{trans("Thumbnail")}</th>
                        {/* <th>
                            <TableHeader onClick={() => onOrderBy("alias")}>
                                {trans("Alias")}
                            </TableHeader>
                        </th> */}
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={3}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={3}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>
                                        {item.thumbnail ? (
                                            <Image
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "60px",
                                                }}
                                                src={item.thumbnail}
                                            />
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteInventoryCategoryId(
                                                    item.uuid
                                                );
                                                setDeleteInventoryCategoryModalShowing(
                                                    true
                                                );
                                                setDeleteInventoryCategoryName(
                                                    item.name
                                                );
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteInventoryCategoryModalShowing && (
                <Modal
                    visible={deleteInventoryCategoryModalShowing}
                    onClose={() => {
                        setDeleteInventoryCategoryModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h1>
                            {trans("You are about delete inventory category")}:
                            {deleteInventoryCategoryName}
                        </h1>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="hollow"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteInventoryCategoryModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteInventoryCategoryId)
                                    .then((data) => {
                                        setDeleteInventoryCategoryModalShowing(
                                            false
                                        );
                                    })
                                    .catch((e) =>
                                        setDeleteInventoryCategoryModalShowing(
                                            false
                                        )
                                    );
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface InventoryCategoryTableProps {
    items: InventoryCategory[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<void>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: (any) => void;
}

export default InventoryCategoryTable;
